export const MINUTE_IN_SECONDS = 60
export const HOUR_IN_SECONDS = MINUTE_IN_SECONDS * 60
export const DAY_IN_SECONDS = HOUR_IN_SECONDS * 24
